export default __webpack_public_path__ + "static/media/Visa.e4b82f57.svg";